import { useMutation } from 'react-query'
import { api } from '../../../api'

type UpdatePasswordPayload = {
  password: string
  passwordConfirmation: string
}

const updateResearcherPassword = async (
  id: number,
  data: UpdatePasswordPayload
) => {
  const response = await api.put(`/researchers/update-password/${id}`, data)
  return response.data
}

export const useResearcherUpdatePasswordMutation = () => {
  return useMutation('update-researcher-password', {
    mutationFn: ({ id, data }: { id: number; data: UpdatePasswordPayload }) =>
      updateResearcherPassword(id, data),
  })
}
